import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { SortModel } from "components/data/DataSource";
import { WebApiDataSource } from "components/data/WebApiDataSource";
import { Link } from "react-router-dom";
import * as API from "common/api/Evidence/Clenove/HostovaniDlouhodoba";
import DataGrid, { Column, DataGridProps } from "components/controls/DataGrid";
import StavLabel from "common/components/evidence/clenove/hostovani-dlouhodoba/StavLabel";
import PageContent from "common/web/PageContent";
import { detail as pathDetail, RouteProps } from "./routes-path";

interface HostovaniDlouhodobaSeznamProps {
    clenId: number;
}

declare type Props = HostovaniDlouhodobaSeznamProps & RouteComponentProps<RouteProps>;

class HostovaniDlouhodobaSeznam extends React.PureComponent<Props> {

    private dataSource: WebApiDataSource<API.HostItem>;
    private columns: Column<API.HostItem>[];

    constructor(props: Props) {
        super(props);

        this.dataSource = new WebApiDataSource(this.getDataAction);
        this.dataSource.setPageSize(20, true);

        const sortedItems: { [index: string]: SortModel } = {
            ['DatPorizeni']: { field: 'DatPorizeni', direction: 'desc' }
        }

        this.dataSource.setSortedItems(sortedItems);

        this.columns = [
            { headerText: "Datum poř.", field: "DatPorizeni", width: 90, type: 'date', format: 'DD.MM.YYYY' },
            { headerText: "Hostování do", field: "HostKlubNazev" },
            { headerText: "Od data", field: "OdData", width: 90, type: 'date', format: 'DD.MM.YYYY' },
            { headerText: "Do data", field: "DoData", width: 90, type: 'date', format: 'DD.MM.YYYY' },
            { headerText: "Stav", field: "Stav", width: 120, render: this.renderStav },
            { field: "_detail", width: 80, render: this.renderDetail },
        ];
    }

    renderStav = (col: Column<API.HostItem>, row: API.HostItem) => {
        return <StavLabel stav={row.Stav} />;
    }

    renderDetail = (col: Column<API.HostItem>, row: API.HostItem) => {
        const { url } = this.props.match;
        //const { lang } = this.props;
        const link = url + pathDetail + '/' + row.Id;
        return <Link to={link}>Detail</Link>;
    }

    getDataAction = () => {
        return API.GetSeznamHostovaniClena(this.props.clenId);
    }

    render() {

        const dgProps: DataGridProps<API.HostItem> = {
            dataSource: this.dataSource,
            columns: this.columns,
            //  query: this.query,
            paginationSettings: {
                pageCount: 5,
                //allowItemsCountInfo: true,
                autoHide: true,
            },
            allowPaging: true,
            //allowResizing: true,
            //allowSorting: true,
            //height: 'grow',
            // height: 300,
            // autoFitColumns:[]

            padding: 'default',
            //  padding: 'dense',
            // gridLines: 'both',
            showBorder: false,
            noItemsContent: <em>{'- není evidováno žádné dlouhodobé hostování -'}</em>,
        }

        return <PageContent titles={['Hostování dlouhodobá']}>
            <DataGrid {...dgProps} />
        </PageContent>;
    }
}

export default withRouter(HostovaniDlouhodobaSeznam); 
